import React from 'react';

function Footer() {
    return (
        <div style={{ textAlign: 'center' }}>
            
            <p>©2023 |Designed and coded with ❤️️ by Abdul Basit</p>
        </div>
    );
}

export default Footer;
